import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import Typography from "@shared/v2/Typography";
import Error from "@shared/Error";

const DeleteAction = ({
  assignedPlan,
  deleteAssignedActionModalOpen,
  closeModal,
  action,
  onActionDelete,
  hasActionError,
  actionErrorMessage,
  showPlanDetails,
}) => (
  <Modal
    className="person-details-modal"
    onHide={closeModal}
    show={deleteAssignedActionModalOpen}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[640px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header title="Do you really want to delete this action?" closeButton />

    <Modal.Body>
      {hasActionError && <Error errorMessage={actionErrorMessage} />}
      <Typography>
        Please note that{" "}
        {action && (
          <span className="tw-font-bold">
            {action.type}: {action.name}{" "}
          </span>
        )}
        is generated from action plan{" "}
        <span className="tw-font-bold"> &quot;{assignedPlan?.name.trim()}&quot; </span>
        and deleting this action will delete all tasks and interactions contingent on that.
      </Typography>
    </Modal.Body>

    <Modal.Footer className="tw-flex tw-justify-between">
      <Button size="medium" schema="tertiary" onClick={closeModal}>
        Cancel
      </Button>
      <Button
        size="medium"
        schema="warning"
        onClick={() => {
          onActionDelete(
            action.id,
            `/assigned_plans/${action.assigned_plan_id}/assigned_actions/${action.id}`,
            () => showPlanDetails(assignedPlan.id),
          );
        }}
      >
        Delete
      </Button>
    </Modal.Footer>
  </Modal>
);

DeleteAction.propTypes = {
  assignedPlan: PropTypes.shape().isRequired,
  deleteAssignedActionModalOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  action: PropTypes.shape().isRequired,
  onActionDelete: PropTypes.func.isRequired,
  hasActionError: PropTypes.bool.isRequired,
  actionErrorMessage: PropTypes.string.isRequired,
  showPlanDetails: PropTypes.func.isRequired,
};

export default DeleteAction;
